module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/view/page-not-found/page-not-found.component.css
// module id = ./src/app/view/page-not-found/page-not-found.component.css
// module chunks = main